module.exports = __webpack_public_path__ + "img/ski_place5.4aab6674.png";